import React from 'react';

const AboutSection = () => {
  return (
    <div className="container-xxl py-5" id="about">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s" style={{ minHeight: '400px' }}>
            <div className="position-relative h-100">
              <img className="img-fluid position-absolute w-100 h-100" src="../assetsTemplates/template1/img/about.jpg" alt="" style={{ objectFit: 'cover' }} />
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
            <h6 className="section-title bg-white text-start text-primary pe-3">About Us</h6>
            <h1 className="mb-4">Welcome to CNI</h1>
            <p className="mb-4">The National Center for Computer Science is a public establishment with non-administrative status, possessing legal personality and financial autonomy. The NCC is an organization under the supervision of the Minister of Communication Technologies, operating in the fields of the computer science and communication technology sector, and certified ISO 9001:2015.</p>
            <div className="row gy-2 gx-4 mb-4">
              <div className="col-sm-6">
                <p className="mb-0"><i className="fa fa-arrow-right text-primary me-2"></i>Assistance</p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0"><i className="fa fa-arrow-right text-primary me-2"></i>Application Development</p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0"><i className="fa fa-arrow-right text-primary me-2"></i>Hosting</p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0"><i className="fa fa-arrow-right text-primary me-2"></i>Business Continuity</p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0"><i className="fa fa-arrow-right text-primary me-2"></i>Training</p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0"><i className="fa fa-arrow-right text-primary me-2"></i>Network Administration</p>
              </div>
            </div>
            <a className="btn btn-primary py-3 px-5 mt-2" href="/About">Read More</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
